export enum BillingPlanId {
  // ClearEstate
  ESSENTIAL = 'Essential',
  PLUS = 'Plus',
  COMPLETE_ESTATE = 'Complete Estate',
  PROBATE = 'Probate',
  PROBATE_AND_TAXES = 'Probate and Taxes',
  PREMIUM_ESTATE = 'Premium Estate',
  SMALL_ESTATE = 'Small Estate',
  EXECUTOR = 'Executor',
  AFTERCARE = 'Aftercare',

  // ClearVault
  INDIVIDUAL_ESSENTIAL_PLAN = 'Individual - Essential Plan',
  COUPLES_ESSENTIAL_PLAN = 'Couples - Essential',

  INDIVIDUAL_STANDARD_PLAN = 'Individual - Standard',
  COUPLES_STANDARD_PLAN = 'Couples - Standard',

  INDIVIDUAL_BASIC_PLAN = 'Individual - Basic',
  COUPLES_BASIC_PLAN = 'Couples - Basic',

  INDIVIDUAL_PLUS_PLAN = 'Individual - Plus',
  COUPLES_PLUS_PLAN = 'Couples - Plus',

  INDIVIDUAL_COMPLETE_PLAN = 'Individual - Complete',
  COUPLES_COMPLETE_PLAN = 'Couples - Complete',

  INDIVIDUAL_PROFESSIONAL_EXECUTOR = 'Individual - Corp Executor',
  COUPLES_PROFESSIONAL_EXECUTOR = 'Couples - Corp Executor',
  INDIVIDUAL_CUSTOM = 'Individual - Signature',
  COUPLES_CUSTOM = 'Couples - Signature',

  INDIVIDUAL_DIGITAL_VAULT = 'Individual - Digital Vault',

  FINANCIAL_ADVISOR_PRO = 'Financial Advisor Pro',
  FINANCIAL_ADVISOR_PRO_ANNUAL = 'Financial Advisor Pro Annual',

  ADVISOR_PRO = 'Advisor Pro',

  // deprecated ClearVault
  LEGACY_INDIVIDUAL_ESSENTIAL_PLAN = 'Legacy Individual - Essential Plan',
  LEGACY_COUPLES_ESSENTIAL_PLAN = 'Legacy Couples - Essential',
  INDIVIDUAL = 'Individual',

  /**
   * @deprecated
   */
  CB_GOOD_PLAN = 'cb_good_plan',
  /**
   * @deprecated
   */
  CB_BETTER_PLAN = 'cb_better_plan',
  /**
   * @deprecated
   */
  CB_BEST_PLAN = 'cb_best_plan'
}
